/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Empty body — request shape kept for forward extensibility (e.g. priority).
 */
export interface LaunchRequest { [key: string]: unknown }
